export class AIError extends Error {
  constructor(code, message) {
    super(message);
    this.code = code;
  }
}

export const ERROR_CODES = {
  RATE_LIMIT_EXCEEDED: 'RATE_LIMIT_EXCEEDED',
  CONTEXT_LENGTH_EXCEEDED: 'CONTEXT_LENGTH_EXCEEDED',
  NETWORK_ERROR: 'NETWORK_ERROR',
  API_ERROR: 'API_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  UNAUTHORIZED: 'UNAUTHORIZED'
};

export const handleAIError = (error) => {
  if (error instanceof AIError) {
    switch (error.code) {
      case ERROR_CODES.RATE_LIMIT_EXCEEDED:
        return 'Bạn đã vượt quá giới hạn số lần gọi API. Vui lòng thử lại sau.';
      case ERROR_CODES.CONTEXT_LENGTH_EXCEEDED:
        return 'Nội dung quá dài. Vui lòng chia nhỏ câu hỏi của bạn.';
      case ERROR_CODES.NETWORK_ERROR:
        return 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối và thử lại.';
      case ERROR_CODES.UNAUTHORIZED:
        return 'Phiên làm việc đã hết hạn. Vui lòng đăng nhập lại.';
      case ERROR_CODES.VALIDATION_ERROR:
        return error.message;
      default:
        return 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
    }
  }
  
  if (error.message.includes('network')) {
    return 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối và thử lại.';
  }
  
  if (error.message.includes('timeout')) {
    return 'Yêu cầu mất quá nhiều thời gian. Vui lòng thử lại.';
  }

  return 'Đã có lỗi xảy ra. Vui lòng thử lại sau.';
};
